module.exports = __webpack_public_path__ + "static/media/audit-user.3d5222d7.svg";